import { Component, Input, OnInit } from '@angular/core';
import { BulletPoint, CategoryPraise, OriginProcessType } from '../../models/userSummaryData';
import { BaseClass } from 'src/app/shared/classes/base';
import { ToastController } from '@ionic/angular';
import { TranslationService } from 'src/app/shared/services/translation.service';

@Component({
    selector: 'app-tag-comments-summary',
    templateUrl: './tag-comments-summary.component.html',
    styleUrls: ['./tag-comments-summary.component.scss'],
})
export class TagCommentsSummaryComponent extends BaseClass implements OnInit {
    @Input() public isExportMode: boolean = false;
    @Input() set selectedTag(value: string){
        this.currentTag = value;
        this.filterBulletPoints();
    };

    @Input() set aiBulletPointsData(value:BulletPoint[]){
        this.aiBulletPoints = value;
        this.filterBulletPoints();
    }
    
    public currentTag: string;
    private aiBulletPoints: BulletPoint[] = [];
    public strengthsPoints: BulletPoint[] = [];
    public weaknessesPoints: BulletPoint[] = [];

    constructor(
        protected _toastController: ToastController,
        protected _translationService: TranslationService,
    ) {
        super(_toastController, _translationService);
     }

    ngOnInit() { }

    private filterBulletPoints() {
        if(!this.aiBulletPoints || this.aiBulletPoints.length == 0) return;
        this.strengthsPoints = this.aiBulletPoints.filter((data) => data.category_praise == CategoryPraise.Elogio);
        this.weaknessesPoints = this.aiBulletPoints.filter((data) => data.category_praise == CategoryPraise.Critica);
    }

    public getProcessTypeName(type:OriginProcessType){
        switch (type) {
            case OriginProcessType.ThreeSixtyEvaluation:
                return this._translationService.getTranslation('performanceCycle.threeSixtyEvaluation');
            case OriginProcessType.FreeEvaluation:
                return this._translationService.getTranslation('dashboard.freeEvaluation');
            case OriginProcessType.Leadership:
                return this._translationService.getTranslation('performanceCycle.threeSixtyEvaluation') + ' Leadership';
            default:
                return '-';
        }
    }

}
